export const FETCH_NOTICES = "notice/fetch";
export const DELETE_NOTICE = "notice/delete";
export const ADD_NOTICE = "notice/add";
export const UPDATE_NOTICE = "notice/update";
export const PING_NOTICE = "notice/ping";
export const FETCH_PUBLISH_NOTICES = "notice/fetchPublish";
